var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('ProjectAccountingTabs',{attrs:{"projectId":_vm.projectId,"active":"expenses"}}),_c('b-table',_vm._b({attrs:{"outlined":""},scopedSlots:_vm._u([{key:"title",fn:function(ref){
var value = ref.value;
var item = ref.item;
return [_c('b-link',{attrs:{"to":{
          name: 'expenses-edit',
          params: { expenseId: item.id }
        }}},[_vm._v("\n        "+_vm._s(value)+"\n      ")])]}},{key:"total",fn:function(ref){
        var value = ref.value;
return [_vm._v("\n      "+_vm._s(value.toLocaleString())+"円\n    ")]}},{key:"actions",fn:function(ref){
        var item = ref.item;
return [_c('b-btn',{attrs:{"variant":"danger"},on:{"click":function($event){return _vm.destroy(item.id)}}},[_vm._v("削除")])]}}])},'b-table',{ fields: _vm.fields, items: _vm.items },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }